import React, { PureComponent, Fragment } from "react";
import { injectIntl, FormattedDate, FormattedHTMLMessage } from "react-intl";
import { accessConfig, initialData } from "./services/access-config";

import Identification from "./Identification";
import BirthDatePicker from "./BirthDatePicker";
import Activities from "./Activities";
import Levels from "./Levels";
import Products from "./Products";
import Meetings from "./Meetings";
import Languages from "./Languages";
import Validation from "./Validation";
import Loader from "./Loader";
import Error from "./Error";

import { fetchAgeRanges } from "./services/clubmed";

import { ChevronLeftIcon } from "./Icons";

import "./Inscription.css";

const renderDate = (date) => (
  <span className="cm-inscription--date">
    {date !== undefined && !isNaN(new Date(date).getTime()) ? (
      <FormattedDate value={date} />
    ) : (
      "Non définie"
    )}
  </span>
);

export default injectIntl(
  class Inscription extends PureComponent {
    accessConfigData = initialData;

    componentDidMount() {
      const {
        intermediary,
        resort,
        lang,
        season,
        stayFrom,
        stayTo,
        ageRangesUpdated,
      } = this.props;
      if (season !== undefined) {
        fetchAgeRanges(
          intermediary,
          resort,
          lang,
          season,
          stayFrom,
          stayTo
        ).then((result) => {
          ageRangesUpdated(result);
        });
      }
    }

    renderIdentification() {
      const { identification, textfieldChanged } = this.props;
      return (
        <Identification
          identification={identification}
          textfieldChanged={textfieldChanged}
        />
      );
    }

    renderBirthdatePicker() {
      const { ageRanges, technicalError, birthDateChanged } = this.props;
      if (ageRanges !== undefined && ageRanges.min !== undefined) {
        return (
          <BirthDatePicker
            min={ageRanges.min}
            max={ageRanges.max}
            onChanged={birthDateChanged}
          />
        );
      }

      if (
        (ageRanges !== undefined && ageRanges.min === undefined) ||
        technicalError
      ) {
        return <Error technicalError={technicalError} kind="ages" />;
      }
    }

    renderActivities() {
      const {
        birthday,
        activities,
        activity,
        technicalError,
        activityChanged,
      } = this.props;
      if (birthday !== undefined) {
        return (
          <Activities
            activities={activities}
            activity={activity}
            onChanged={activityChanged}
            technicalError={technicalError}
          />
        );
      }
    }

    renderLevels() {
      const { activity, levels, level, technicalError, levelChanged } =
        this.props;
      if (activity !== undefined) {
        return (
          <Levels
            levels={levels}
            level={level}
            onChanged={levelChanged}
            technicalError={technicalError}
          />
        );
      }
    }

    renderProducts() {
      const { level, products, product, technicalError, productChanged } =
        this.props;
      if (level !== undefined) {
        return (
          <Products
            products={products}
            product={product}
            onChanged={productChanged}
            technicalError={technicalError}
          />
        );
      }
    }

    renderMeetings() {
      const { product, meetings, meeting, technicalError, meetingChanged } =
        this.props;

      if (product !== undefined) {
        if (meetings === undefined && !technicalError) {
          return <Loader loading={true} />;
        }

        if (
          meeting === undefined &&
          (technicalError || meetings.length === 0)
        ) {
          return <Error technicalError={technicalError} kind="meetings" />;
        }

        if (meetings.length > 1) {
          return (
            <Meetings
              meetings={meetings}
              meeting={meeting}
              onChanged={meetingChanged}
            />
          );
        }
      }
    }

    renderLanguages() {
      const { meeting, languages, language, technicalError, languageChanged } =
        this.props;

      if (meeting !== undefined) {
        if (languages === undefined && !technicalError) {
          return <Loader loading={true} />;
        }

        if (
          language === undefined &&
          (technicalError || languages.length === 0)
        ) {
          return <Error technicalError={technicalError} kind="languages" />;
        }

        if (
          languages.length > 0 &&
          (languages.length > 1 || languages[0].code !== "fr")
        ) {
          return (
            <Languages
              languages={languages}
              language={language}
              onChanged={languageChanged}
            />
          );
        }
      }
    }

    renderValidation() {
      const {
        language,
        validating,
        validation,
        technicalError,
        doublon,
        newInscription,
      } = this.props;
      if (language !== undefined) {
        return technicalError ? (
          <Error kind="order" />
        ) : doublon ? (
          <Error kind="doublon" buttonAction={newInscription} />
        ) : (
          <Validation validating={validating} validation={validation} />
        );
      }
    }

    renderError() {
      return <Error kind="season" />;
    }

    renderProcess() {
      return (
        <Fragment>
          <div className="cm-inscription--body">
            {this.renderIdentification()}
            {this.renderBirthdatePicker()}
            {this.renderActivities()}
            {this.renderLevels()}
          </div>
          {this.renderProducts()}
          {this.renderMeetings()}
          {this.renderLanguages()}
          {this.renderValidation()}
        </Fragment>
      );
    }

    renderInscription() {
      const { season, stayFrom, stayTo, newInscription, intl } = this.props;
      return (
        <div className="cm-inscription--outer">
          <div
            className="cm-inscription--logo"
            onClick={accessConfig(
              this.accessConfigData,
              this.props.navToConfig
            )}
          >
            {/* <img src="/images/logo-clubmed.svg" alt="Club Med" /> */}
          </div>
          <div className="cm-inscription--header">
            <div className="cm-inscription--title">
              <button
                onClick={newInscription}
                className="cm-inscription--new-inscription"
              >
                <ChevronLeftIcon className="cm-inscription--icon" />
                <FormattedHTMLMessage id="new_inscription" />
              </button>
            </div>
            <div
              className="cm-inscription--header-stay"
              onClick={accessConfig(
                this.accessConfigData,
                this.props.navToConfig
              )}
            >
              <span className="cm-inscription--group-classes cm-inscription__collapsable1">
                {intl.messages.group_classes}
              </span>{" "}
              <span className="cm-inscription--text__normal">
                {intl.messages.from}
              </span>{" "}
              {renderDate(stayFrom)}{" "}
              <span className="cm-inscription--text__normal">
                {intl.messages.to}
              </span>{" "}
              {renderDate(stayTo)}
            </div>
          </div>
          <div className="cm-inscription--bandeau">
            <img src="/images/logo-esf.svg" alt="ESF" />
          </div>
          {season !== undefined ? this.renderProcess() : this.renderError()}
        </div>
      );
    }

    render() {
      return <div>{this.renderInscription()}</div>;
    }
  }
);



// WEBPACK FOOTER //
// ./src/Inscription.js